export const translations = {
  pt: {
    nav: {
      home: "Início",
      about: "Sobre",
      accommodations: "Acomodações",
      location: "Localização",
      gallery: "Galeria",
      contact: "Contacto",
      book: "Reservar",
    },
    hero: {
      badge: "Costa de Prata, Portugal",
      title: "Glamp Your Holiday",
      subtitle: "Experiências de Glamping na Costa de Prata",
      description: "Sinta a natureza de perto. Uma localização única entre o Parque Natural da Serra de Aire e Candeeiros e as maiores ondas do mundo na Nazaré.",
      cta: "Ver Acomodações",
      ctaBook: "Reservar Agora",
      scroll: "Descubra",
    },
    about: {
      badge: "A Nossa História",
      title: "Glamping como deve ser",
      text1: "Eco Glamping em Portugal — uma escapada na natureza da bela região da Costa de Prata. Viva a experiência nas nossas acomodações únicas de glamping no centro de Portugal, perto da costa.",
      text2: "A Quinta das Cantigas tem um total de 8 acomodações em 10.000 m², das quais 4 são glamping únicas espalhadas entre os carvalhos, oliveiras e outras árvores de fruto. Cada uma com muito sol e sombra, muita privacidade, simples e únicas, com todas as comodidades modernas.",
      text3: "Não fazemos glamping mainstream. Hospitalidade, Originalidade, Aconchego e Privacidade — partilhe momentos únicos, simplesmente aproveite e Glamp On!",
      quote: "Think Outside, No Box Required",
      features: [
        { title: "Privacidade Total", desc: "Grandes lotes com muito espaço e privacidade, longe da multidão" },
        { title: "Piscinas Aquecidas", desc: "Um amplo refúgio aquático aquecido, com zonas seguras dedicadas para as crianças brincarem e nadarem livremente." },
        { title: "Localização Privilegiada", desc: "A 15 km da Nazaré e perto de Alcobaça" },
        { title: "Família & Amigos", desc: "Resort eco-friendly, adequado para crianças e grupos de amigos" },
      ],
      hostsLabel: "Os seus anfitriões",
      hostsName: "Sandra & Maurice",
      hostsQuote: "Com atenção pessoal aos detalhes e hospitalidade, deixamo-lo livre para desfrutar com os seus amigos e família!",
    },
    accommodations: {
      badge: "As Nossas Acomodações",
      title: "4 Experiências Únicas de Glamping",
      subtitle: "Cada acomodação foi concebida para oferecer uma experiência única e inesquecível na natureza.",
      guests: "Hóspedes",
      size: "Dimensão",
      view: "Vista",
      amenities: "Comodidades",
      book: "Reservar",
      moreInfo: "Mais Informações",
      close: "Fechar",
      prevImg: "Anterior",
      nextImg: "Seguinte",
      items: [
        {
          id: "tendas-toca",
          name: "Tendas Toca",
          tagline: "As Tendas da Aventura",
          description: "Duas 'casas-tenda' individuais com instalações modernas formam uma única acomodação, proporcionando privacidade para a família ou amigos. Do terraço amplo e sombreado tem vista para o parque infantil e piscina. Pode preparar as refeições na cozinha exterior e relaxar na rede. Não é rodeado de vizinhos, mas pode desfrutar de tudo o que este acolhedor e pequeno resort sustentável tem para oferecer.",
          size: "100 m²",
          guests: 6,
          view: "Natureza, piscina, pomar",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca-1350x581.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-2-camping-pods.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_front-view.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_sideview.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_master-bed.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_kitchen.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-to-pool.jpg",
          ],
          amenities: ["Wi-Fi", "Piscinas Aquecidas", "BBQ Privado", "Cozinha Exterior", "Casa de Banho Privada", "Estacionamento", "Roupa de Cama"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "cabanas-figo",
          name: "Cabanas O Figo",
          tagline: "Vida ao Ar Livre em Privacidade",
          description: "Viva ao ar livre nesta adorável acomodação de glamping em madeira com o luxo de uma casa pequena. Composta por 2 cabanas e com muita privacidade e a sua própria figueira. Sol e sombra proporcionam um ambiente encantador da manhã cedo ao fim da tarde. Os miúdos brincam no parque florestal enquanto o pai acende o grande BBQ.",
          size: "90 m²",
          guests: 5,
          view: "Jardim, natureza",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_front-view-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_terrace-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_garden-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_kichinette-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-Figo-cabin-3-persons-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-figo_medronho-cabin-2-persons-1.jpg",
          ],
          amenities: ["Wi-Fi", "Piscinas Aquecidas", "BBQ Privado", "Cozinha Exterior", "Casa de Banho Privada", "Estacionamento", "Roupa de Cama"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "cabanas-medronho",
          name: "Cabanas O Medronho",
          tagline: "Natureza e Tranquilidade",
          description: "Rodeado de árvores magníficas, descanse tranquilamente na sua rede. Os pássaros cantam e o sol brilha. Os mais pequenos brincam na sua própria cabana enquanto o pai vai de bicicleta. Nunca pensou que o Glamping fosse tão relaxante. É fantástico aqui, um lugar a que se regressa todos os anos!",
          size: "90 m²",
          guests: 6,
          view: "Natureza, jardim",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho-02.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_cabana.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_terras.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_garden.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_kids-cabin.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-medronho-cabin-4-persons-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_private-bathroom.jpg",
          ],
          amenities: ["Wi-Fi", "Piscinas Aquecidas", "BBQ Privado", "Cozinha Exterior", "Casa de Banho Privada", "Estacionamento", "Roupa de Cama"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "vintage-ford",
          name: "A Rode Ford 1972",
          tagline: "Uma Experiência Vintage Inesquecível",
          description: "Vai numa viagem? É assim que se sente ao ficar nesta Ford vermelha vintage de 1972. Uma experiência de glamping muito especial com muita privacidade, no meio da natureza. Pode relaxar, aproximar-se, e não precisa de sair pelos imensos jogos e atividades ao ar livre disponíveis. Acende o BBQ e aproveita!",
          size: "80 m²",
          guests: 4,
          view: "Natureza, jardim",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_front-view.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_terrace.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_night.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_interior.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_double-bed.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_detail.jpg",
          ],
          amenities: ["Wi-Fi", "Piscinas Aquecidas", "BBQ Privado", "Cozinha Exterior", "Casa de Banho Privada", "Estacionamento"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
      ],
    },
    location: {
      badge: "Localização",
      title: "Costa de Prata, Portugal",
      subtitle: "Entre o Parque Natural da Serra de Aire e Candeeiros e as maiores ondas do mundo em Nazaré.",
      mapTitle: "Quinta das Cantigas — Alcobaça, Portugal",
      discoverLabel: "Descubra a Região",
      pois: [
        {
          name: "Nazaré",
          icon: "waves",
          distance: "15 km",
          desc: "Famosa pelas maiores ondas do mundo. Fantásticas praias, boulevard com lojas, restaurantes e animação durante todo o ano.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/praia-do-norte.jpg",
        },
        {
          name: "Alcobaça",
          icon: "landmark",
          distance: "10 km",
          desc: "A 'Cidade do Amor'. Mosteiro Patrimônio UNESCO, o maior museu do vinho do país, e a história de amor imortal de Dom Pedro e Inês de Castro.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/doces-conventueis-de-alcobaca.jpg",
        },
        {
          name: "Praias",
          icon: "sun",
          distance: "15-20 km",
          desc: "A Costa de Prata tem praias magníficas. Praia do Norte, Praia da Nazaré e Praia de Paredes da Vitória — escolha a sua favorita.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/portugal-praia-paredes-da-vitoria-beach-1024x588.jpg",
        },
        {
          name: "Atividades",
          icon: "bike",
          distance: "Na região",
          desc: "Ciclismo, caminhadas, surf, observação de golfinhos, 4x4 off-road. Serviço de aluguer de bicicletas e guias locais disponíveis.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/fort-nazare.jpg",
        },
      ],
    },
    gallery: {
      badge: "Galeria",
      title: "Momentos no Glamping",
      subtitle: "Fotos reais do nosso alojamento — sem filtros, sem artificialidade. A nossa natureza fala por si.",
      categories: ["Todos", "Acomodações", "Natureza & Jardim", "Localização"],
      openLabel: "Ver foto",
      closeLabel: "Fechar",
    },
   contact: {
      badge: "Contacto",
      title: "Vamos Falar",
      subtitle: "Adorávamos recebê-lo! Acreditamos na atenção personalizada e privacidade. Respondemos o mais depressa possível.",
      whatsapp: "WhatsApp",
      signal: "Signal",
      contactSub: "Disponível para mensagens",
      availability: "Disponibilidade",
      availabilitySub: "Consultar calendário",
      infoTitle: "Informação de contacto",
      address: "Alcobaça, Portugal",
      email: "welcome@yourholiday.pt",
      phones: "Sandra: +351 919 133 855 | Maurice: +351 919 133 750",
      office: "Escritório: +351 262 588 255",
      // O form pode ficar aqui em baixo se o usares noutro sítio
      form: {
        name: "Nome",
        email: "E-mail",
        phone: "Telefone",
        message: "Mensagem",
        submit: "Enviar",
      },
      info: {
        title: "Informações de Contacto",
        address: "Alcobaça, Costa de Prata, Portugal",
        email: "welcome@yourholiday.pt",
        phone1: "Sandra: +351 919 133 855",
        phone2: "Maurice: +351 919 133 750",
        office: "Escritório: +351 262 588 255",
        whatsapp: "WhatsApp & Signal disponível",
        bookDirect: "Reservar diretamente:",
        bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        bookLabel: "Ver Disponibilidade & Reservar",
      },
    },
    footer: {
      tagline: "Eco Glamping em Portugal — A Costa de Prata espera por si.",
      quickLinks: "Links Rápidos",
      contactTitle: "Contacto",
      legalTitle: "Legal",
      privacy: "Política de Privacidade",
      terms: "Termos & Condições",
      complaints: "Livro de Reclamações",
      company: "YourHoliday.PT é uma marca de Couwenberg & Van Kessel LDA. NIF 509470149",
      copyright: "© 2026 YourHoliday.PT. Todos os direitos reservados.",
      bookNow: "Reservar Agora",
      sustainableLabel: "Turismo Sustentável",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      accommodations: "Accommodations",
      location: "Location",
      gallery: "Gallery",
      contact: "Contact",
      book: "Book Now",
    },
    hero: {
      badge: "Silver Coast, Portugal",
      title: "Glamp Your Holiday",
      subtitle: "Glamping Experiences at the Silver Coast",
      description: "Feel nature closely. A unique location between the Serra de Aire e Candeeiros Natural Park and the biggest waves in the world at Nazaré.",
      cta: "View Accommodations",
      ctaBook: "Book Now",
      scroll: "Discover",
    },
    about: {
      badge: "Our Story",
      title: "Glamping as it's meant to be",
      text1: "Eco Glamping in Portugal — a getaway in nature of the beautiful region 'the Silver Coast'. Experience the holiday feeling in our unique glamping accommodations in central Portugal, near the coast.",
      text2: "Quinta das Cantigas has a total of 8 accommodations on 10,000 m², of which 4 unique glamping accommodations are spread between the (cork) oaks, olive and other fruit trees. Each of them has plenty of sun and shade, a lot of privacy, simple and unique, with all modern conveniences.",
      text3: "We don't do mainstream glamping. Hospitality, Originality, Coziness and Privacy — share unique moments, simply enjoy and Glamp On!",
      quote: "Think Outside, No Box Required",
      features: [
        { title: "Total Privacy", desc: "Big plots with lots of space and privacy, away from the crowds" },
        { title: "Heated Swimming Pools", desc: "A spacious, heated aquatic retreat featuring dedicated safe zones for children to play and swim freely" },
        { title: "Prime Location", desc: "15 km from Nazaré and close to Alcobaça" },
        { title: "Family & Friends", desc: "Child-friendly eco resort, perfect for families and groups of friends" },
      ],
      hostsLabel: "Your hosts",
      hostsName: "Sandra & Maurice",
      hostsQuote: "With our personal attention to detail and hospitality, we leave you free to enjoy and be one with your friends and family!",
    },
    accommodations: {
      badge: "Our Accommodations",
      title: "4 Unique Glamping Experiences",
      subtitle: "Each accommodation was designed to offer a unique and unforgettable experience in nature.",
      guests: "Guests",
      size: "Size",
      view: "View",
      amenities: "Amenities",
      book: "Book",
      moreInfo: "More Info",
      close: "Close",
      prevImg: "Previous",
      nextImg: "Next",
      items: [
        {
          id: "tendas-toca",
          name: "Tendas Toca",
          tagline: "The Adventure Tents",
          description: "Two individual 'tent houses' with modern facilities make up one holiday accommodation, providing privacy for your family or friends. From the large, shaded terrace you overlook the playground and pool. You can prepare your meals at the outdoor kitchen and relax in the hammock. You are not surrounded by neighbours, but you can enjoy everything this cozy, small, child-friendly and sustainable resort has to offer.",
          size: "100 m²",
          guests: 6,
          view: "Nature, pool, orchard",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca-1350x581.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-2-camping-pods.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_front-view.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_sideview.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_master-bed.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_kitchen.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-to-pool.jpg",
          ],
          amenities: ["Wi-Fi", "Heated Pools", "Private BBQ", "Outdoor Kitchen", "Private Bathroom", "Parking", "Bed Linen"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "cabanas-figo",
          name: "Cabanas O Figo",
          tagline: "Outdoor Living in Total Privacy",
          description: "Come enjoy outdoor living in this lovely wooden glamping accommodation with the luxury of a tiny house. Consisting of 2 cabanas and with plenty of privacy and your own fig tree. Sun and shade provide for a lovely setting from early morning to late afternoon. The kids enjoy playing in the play forest while dad lights the big BBQ.",
          size: "90 m²",
          guests: 5,
          view: "Garden, nature",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_front-view-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_terrace-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_garden-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_kichinette-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-Figo-cabin-3-persons-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-figo_medronho-cabin-2-persons-1.jpg",
          ],
          amenities: ["Wi-Fi", "Heated Pools", "Private BBQ", "Outdoor Kitchen", "Private Bathroom", "Parking", "Bed Linen"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "cabanas-medronho",
          name: "Cabanas O Medronho",
          tagline: "Nature and Tranquility",
          description: "Surrounded by beautiful trees, you are lazy in your hammock. The birds are singing, and the sun is shining. The little ones play in their own cabana, while dad is out cycling. You never thought that Glamping is so relaxed. It's fantastic here, a great place to come back to, next year, with friends!",
          size: "90 m²",
          guests: 6,
          view: "Nature, garden",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho-02.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_cabana.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_terras.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_garden.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_kids-cabin.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-medronho-cabin-4-persons-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_private-bathroom.jpg",
          ],
          amenities: ["Wi-Fi", "Heated Pools", "Private BBQ", "Outdoor Kitchen", "Private Bathroom", "Parking", "Bed Linen"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "vintage-ford",
          name: "The Red Ford 1972",
          tagline: "An Unforgettable Vintage Experience",
          description: "Are you going on a trip? Yes, that's how it feels to stay in this red vintage Ford from 1972. A very special glamping experience with plenty of privacy, in the middle of nature. You can relax, become closer to each other, and don't need to leave the grounds due to all the indoor and outdoor play, sports and relax facilities.",
          size: "80 m²",
          guests: 4,
          view: "Nature, garden",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_front-view.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_terrace.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_night.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_interior.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_double-bed.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_detail.jpg",
          ],
          amenities: ["Wi-Fi", "Heated Pools", "Private BBQ", "Outdoor Kitchen", "Private Bathroom", "Parking"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
      ],
    },
    location: {
      badge: "Location",
      title: "Silver Coast, Portugal",
      subtitle: "Between the Serra de Aire e Candeeiros Natural Park and the biggest waves in the world at Nazaré.",
      mapTitle: "Quinta das Cantigas — Alcobaça, Portugal",
      discoverLabel: "Discover the Region",
      pois: [
        {
          name: "Nazaré",
          icon: "waves",
          distance: "15 km",
          desc: "World-famous for the biggest waves in the world. Fantastic beaches, boulevard with shops, restaurants and entertainment year-round.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/praia-do-norte.jpg",
        },
        {
          name: "Alcobaça",
          icon: "landmark",
          distance: "10 km",
          desc: "The 'City of Love'. UNESCO Heritage Monastery, the largest wine museum in the country, and the immortal love story of Dom Pedro and Inês de Castro.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/doces-conventueis-de-alcobaca.jpg",
        },
        {
          name: "Beaches",
          icon: "sun",
          distance: "15–20 km",
          desc: "The Silver Coast has magnificent beaches. Praia do Norte, Praia da Nazaré and Praia de Paredes da Vitória — find your favourite.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/portugal-praia-paredes-da-vitoria-beach-1024x588.jpg",
        },
        {
          name: "Activities",
          icon: "bike",
          distance: "In the region",
          desc: "Cycling, hiking, surfing, dolphin watching, 4x4 off-road. Bike rental service and local guided tours available.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/fort-nazare.jpg",
        },
      ],
    },
    gallery: {
      badge: "Gallery",
      title: "Moments at the Glamping",
      subtitle: "Real photos from our accommodation — no filters, no artificiality. Our nature speaks for itself.",
      categories: ["All", "Accommodations", "Nature & Garden", "Location"],
      openLabel: "View photo",
      closeLabel: "Close",
    },
   contact: {
      badge: "Contact",
      title: "Let's Talk",
      subtitle: "We'd love to have you! We believe in personal attention and privacy. We respond as quickly as possible.",
      whatsapp: "WhatsApp",
      signal: "Signal",
      contactSub: "Available for messages",
      availability: "Availability",
      availabilitySub: "Check calendar",
      infoTitle: "Contact Information",
      address: "Alcobaça, Portugal",
      email: "welcome@yourholiday.pt",
      phones: "Sandra: +351 919 133 855 | Maurice: +351 919 133 750",
      office: "Office: +351 262 588 255",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Message",
        submit: "Send Message",
      },
      info: {
        title: "Contact Information",
        address: "Alcobaça, Silver Coast, Portugal",
        email: "welcome@yourholiday.pt",
        phone1: "Sandra: +351 919 133 855",
        phone2: "Maurice: +351 919 133 750",
        office: "Office: +351 262 588 255",
        whatsapp: "WhatsApp & Signal available",
        bookDirect: "Book directly:",
        bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        bookLabel: "Check Availability & Book",
      },
    },
    footer: {
      tagline: "Eco Glamping in Portugal — The Silver Coast awaits you.",
      quickLinks: "Quick Links",
      contactTitle: "Contact",
      legalTitle: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      complaints: "Complaints Book",
      company: "YourHoliday.PT is a trademark of Couwenberg & Van Kessel LDA. NIF 509470149",
      copyright: "© 2025 YourHoliday.PT. All rights reserved.",
      bookNow: "Book Now",
      sustainableLabel: "Sustainable Tourism",
    },
  },
  nl: {
    nav: {
      home: "Home",
      about: "Over ons",
      accommodations: "Accommodaties",
      location: "Locatie",
      gallery: "Galerij",
      contact: "Contact",
      book: "Boek Nu",
    },
    hero: {
      badge: "Zilveren Kust, Portugal",
      title: "Glamp Your Holiday",
      subtitle: "Glamping ervaringen aan de Zilveren Kust",
      description: "Voel de natuur van dichtbij. Een unieke locatie tussen het natuurpark Serra de Aire e Candeeiros en de hoogste golven ter wereld in Nazaré.",
      cta: "Bekijk Accommodaties",
      ctaBook: "Boek Nu",
      scroll: "Ontdek",
    },
    about: {
      badge: "Ons Verhaal",
      title: "Glamping zoals het bedoeld is",
      text1: "Eco Glamping in Portugal — een uitje in de natuur van de prachtige regio de 'Zilveren Kust'. Ervaar het vakantiegevoel in onze unieke glamping accommodaties op onze prachtige locatie in Centraal-Portugal , vlakbij de kust.",
      text2: "Quinta das Cantigas heeft in totaal 8 accommodaties op 10.000 m², waarvan 4 unieke glamping accommodaties verspreid tussen de (kurk)eiken, olijf- en andere fruitbomen. Elk van hen heeft voldoende zon en schaduw, veel privacy, eenvoudig en uniek, met alle moderne gemakken.",
      text3: "Wij doen niet aan mainstream glamping. Gastvrijheid, Originaliteit, Gezelligheid en Privacy — deel unieke momenten, geniet gewoon en Glamp On!",
      quote: "Think Outside, No Box Required",
      features: [
        { title: "Totale Privacy", desc: "Grote percelen met veel ruimte en privacy, weg van de drukte" },
        { title: "Verwarmde Zwembaden", desc: "Een ruim, verwarmd waterparadijs met speciale veilige zones waar kinderen vrijuit kunnen spelen en zwemmen" },
        { title: "Toplocatie", desc: "15 km van Nazaré en dicht bij Alcobaça" },
        { title: "Familie & Vrienden", desc: "Kindvriendelijk eco-resort, perfect voor gezinnen en vriendengroepen" },
      ],
      hostsLabel: "Uw gastheren",
      hostsName: "Sandra & Maurice",
      hostsQuote: "Met onze persoonlijke aandacht voor detail en gastvrijheid laten we u vrij om te genieten met uw vrienden en familie!",
    },
    accommodations: {
      badge: "Onze Accommodaties",
      title: "4 Unieke Glamping Ervaringen",
      subtitle: "Elke accommodatie is ontworpen om een unieke en onvergetelijke ervaring in de natuur te bieden.",
      guests: "Gasten",
      size: "Grootte",
      view: "Uitzicht",
      amenities: "Voorzieningen",
      book: "Boek",
      moreInfo: "Meer Info",
      close: "Sluiten",
      prevImg: "Vorige",
      nextImg: "Volgende",
      items: [
        {
          id: "tendas-toca",
          name: "Tendas Toca",
          tagline: "De Avontuurlijke Tenten",
          description: "Twee individuele 'tenthuisjes' met moderne faciliteiten vormen één vakantieverblijf, wat privacy biedt voor uw gezin of vrienden. Vanaf het grote, schaduwrijke terras kijkt u uit op de speeltuin en het zwembad. U kunt uw maaltijden bereiden in de buitenkeuken en ontspannen in de hangmat. U bent niet omringd door buren, maar u kunt genieten van alles wat dit gezellige, kleine, kindvriendelijke en duurzame resort te bieden heeft.",
          size: "100 m²",
          guests: 6,
          view: "Natuur, zwembad, boomgaard",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca-1350x581.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-2-camping-pods.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_front-view.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_sideview.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_master-bed.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_kitchen.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-to-pool.jpg",
          ],
          amenities: ["Wi-Fi", "Verwarmde Zwembaden", "Privé BBQ", "Buitenkeuken", "Eigen Badkamer", "Parkeren", "Beddengoed"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "cabanas-figo",
          name: "Cabanas O Figo",
          tagline: "Buitenleven in Totale Privacy",
          description: "Kom genieten van het buitenleven in deze heerlijke houten glamping accommodatie met de luxe van een tiny house. Bestaande uit 2 cabana's en met veel privacy en uw eigen vijgenboom. Zon en schaduw zorgen voor een heerlijke setting van de vroege ochtend tot de late namiddag. De kinderen genieten van het spelen in het speelbos terwijl papa de grote BBQ aansteekt.",
          size: "90 m²",
          guests: 5,
          view: "Tuin, natuur",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_front-view-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_terrace-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_garden-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_kichinette-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-Figo-cabin-3-persons-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-figo_medronho-cabin-2-persons-1.jpg",
          ],
          amenities: ["Wi-Fi", "Verwarmde Zwembaden", "Privé BBQ", "Buitenkeuken", "Eigen Badkamer", "Parkeren", "Beddengoed"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "cabanas-medronho",
          name: "Cabanas O Medronho",
          tagline: "Natuur en Rust",
          description: "Omringd door prachtige bomen, luiert u in uw hangmat. De vogels zingen en de zon schijnt. De kleintjes spelen in hun eigen cabana, terwijl papa aan het fietsen is. U had nooit gedacht dat Glamping zo ontspannen zou zijn. Het is hier fantastisch, een geweldige plek om volgend jaar terug te komen met vrienden!",
          size: "90 m²",
          guests: 6,
          view: "Natuur, tuin",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho-02.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_cabana.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_terras.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_garden.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_kids-cabin.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-medronho-cabin-4-persons-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_private-bathroom.jpg",
          ],
          amenities: ["Wi-Fi", "Verwarmde Zwembaden", "Privé BBQ", "Buitenkeuken", "Eigen Badkamer", "Parkeren", "Beddengoed"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "vintage-ford",
          name: "De Rode Ford 1972",
          tagline: "Een Onvergetelijke Vintage Ervaring",
          description: "Gaat u op reis? Ja, zo voelt het om in deze rode vintage Ford uit 1972 te verblijven. Een heel bijzondere glamping ervaring met veel privacy, midden in de natuur. U kunt ontspannen, dichter bij elkaar komen en hoeft het terrein niet te verlaten dankzij alle speel-, sport- en ontspanningsfaciliteiten voor binnen en buiten.",
          size: "80 m²",
          guests: 4,
          view: "Natuur, tuin",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_front-view.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_terrace.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_night.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_interior.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_double-bed.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_detail.jpg",
          ],
          amenities: ["Wi-Fi", "Verwarmde Zwembaden", "Privé BBQ", "Buitenkeuken", "Eigen Badkamer", "Parkeren"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
      ],
    },
    location: {
      badge: "Locatie",
      title: "Zilveren Kust, Portugal",
      subtitle: "Tussen het natuurpark Serra de Aire e Candeeiros en de hoogste golven ter wereld in Nazaré.",
      mapTitle: "Quinta das Cantigas — Alcobaça, Portugal",
      discoverLabel: "Ontdek de Regio",
      pois: [
        {
          name: "Nazaré",
          icon: "waves",
          distance: "15 km",
          desc: "Wereldberoemd om de hoogste golven ter wereld. Fantastische stranden, boulevard met winkels, restaurants en het hele jaar door entertainment.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/praia-do-norte.jpg",
        },
        {
          name: "Alcobaça",
          icon: "landmark",
          distance: "10 km",
          desc: "De 'Stad van de Liefde'. UNESCO Werelderfgoed Klooster, het grootste wijnmuseum van het land, en het onsterfelijke liefdesverhaal van Dom Pedro en Inês de Castro.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/doces-conventueis-de-alcobaca.jpg",
        },
        {
          name: "Stranden",
          icon: "sun",
          distance: "15–20 km",
          desc: "De Zilveren Kust heeft prachtige stranden. Praia do Norte, Praia da Nazaré en Praia de Paredes da Vitória — ontdek uw favoriet.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/portugal-praia-paredes-da-vitoria-beach-1024x588.jpg",
        },
        {
          name: "Activiteiten",
          icon: "bike",
          distance: "In de regio",
          desc: "Fietsen, wandelen, surfen, dolfijnen kijken, 4x4 off-road. Fietsverhuur en lokale rondleidingen beschikbaar.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/fort-nazare.jpg",
        },
      ],
    },
    gallery: {
      badge: "Galerij",
      title: "Momenten op de Glamping",
      subtitle: "Echte foto's van onze accommodatie — geen filters, geen kunstmatigheid. Onze natuur spreekt voor zich.",
      categories: ["Alle", "Accommodaties", "Natuur & Tuin", "Locatie"],
      openLabel: "Foto bekijken",
      closeLabel: "Sluiten",
    },
    contact: {
      badge: "Contact",
      title: "Laten we praten",
      subtitle: "We verwelkomen u graag! Wij geloven in persoonlijke aandacht en privacy. Wij reageren zo snel mogelijk.",
      whatsapp: "WhatsApp",
      signal: "Signal",
      contactSub: "Beschikbaar voor berichten",
      availability: "Beschikbaarheid",
      availabilitySub: "Bekijk kalender",
      infoTitle: "Contactgegevens",
      address: "Alcobaça, Portugal",
      email: "welcome@yourholiday.pt",
      phones: "Sandra: +351 919 133 855 | Maurice: +351 919 133 750",
      office: "Kantoor: +351 262 588 255",
      form: {
        name: "Naam",
        email: "E-mail",
        phone: "Telefoon",
        message: "Bericht",
        submit: "Versturen",
     },
      info: {
        title: "Contactinformatie",
        address: "Alcobaça, Zilveren Kust, Portugal",
        email: "welcome@yourholiday.pt",
        phone1: "Sandra: +351 919 133 855",
        phone2: "Maurice: +351 919 133 750",
        office: "Kantoor: +351 262 588 255",
        whatsapp: "WhatsApp & Signal beschikbaar",
        bookDirect: "Direct boeken:",
        bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        bookLabel: "Beschikbaarheid controleren & boeken",
      },
    },
    footer: {
      tagline: "Eco Glamping in Portugal — De Zilveren Kust wacht op u.",
      quickLinks: "Snelkoppelingen",
      contactTitle: "Contact",
      legalTitle: "Juridisch",
      privacy: "Privacybeleid",
      terms: "Algemene Voorwaarden",
      complaints: "Klachtenboek",
      company: "YourHoliday.PT is een handelsmerk van Couwenberg & Van Kessel LDA. NIF 509470149",
      copyright: "© 2025 YourHoliday.PT. Alle rechten voorbehouden.",
      bookNow: "Boek Nu",
      sustainableLabel: "Duurzaam Toerisme",
    },
  },
es: {
    nav: {
      home: "Inicio",
      about: "Sobre nosotros",
      accommodations: "Alojamientos",
      location: "Ubicación",
      gallery: "Galería",
      contact: "Contacto",
      book: "Reservar Ahora",
    },
    hero: {
      badge: "Costa de Plata, Portugal",
      title: "Glamp Your Holiday",
      subtitle: "Experiencias de Glamping en la Costa de Plata",
      description: "Siente la naturaleza de cerca. Una ubicacion única entre el Parque Natural Serra de Aire e Candeeiros y las olas más grandes del mundo en Nazaré.",
      cta: "Ver Alojamientos",
      ctaBook: "Reservar Ahora",
      scroll: "Descubrir",
    },
    about: {
      badge: "Nuestra Historia",
      title: "Glamping como debe ser",
      text1: "Eco Glamping en Portugal — una escapada a la naturaleza en la hermosa región de la 'Costa de Plata'. Experimente la sensación de vacaciones en nuestros alojamientos de glamping únicos en una ubicacione en el centro de Portugal, cerca de la costa.",
      text2: "Quinta das Cantigas tiene un total de 8 alojamientos en 10.000 m², de los cuales 4 son alojamientos de glamping únicos distribuidos entre alcornoques, olivos y otros árboles frutales. Cada uno tiene suficiente sol y sombra, mucha privacidad, sencillez y exclusividad, con todas las comodidades modernas.",
      text3: "No hacemos glamping convencional. Hospitalidad, Originalidad, Convivencia y Privacidad — comparta momentos únicos, ¡simplemente disfrute y Glamp On!",
      quote: "Think Outside, No Box Required",
      features: [
        { title: "Privacidad Total", desc: "Grandes parcelas con mucho espacio y privacidad, lejos de las multitudes" },
        { title: "Piscinas Climatizadas", desc: "Un amplio refugio acuático climatizado con zonas seguras dedicadas para que los niños jueguen y naden libremente" },
        { title: "Ubicación Top", desc: "A 15 km de Nazaré y cerca de Alcobaça" },
        { title: "Familia y Amigos", desc: "Eco-resort ideal para niños, perfecto para familias y grupos de amigos" },
      ],
      hostsLabel: "Sus anfitriones",
      hostsName: "Sandra & Maurice",
      hostsQuote: "Con nuestra atención personalizada al detalle y hospitalidad, ¡le dejamos libre para disfrutar con sus amigos y familia!",
    },
    accommodations: {
      badge: "Nuestros Alojamientos",
      title: "4 Experiencias Únicas de Glamping",
      subtitle: "Cada alojamiento está diseñado para ofrecer una experiencia única e inolvidable en la naturaleza.",
      guests: "Huéspedes",
      size: "Tamaño",
      view: "Vistas",
      amenities: "Comodidades",
      book: "Reservar",
      moreInfo: "Más Info",
      close: "Cerrar",
      prevImg: "Anterior",
      nextImg: "Siguiente",
      items: [
        {
          id: "tendas-toca",
          name: "Tendas Toca",
          tagline: "Las Tiendas de Aventura",
          description: "Dos 'casitas de campaña' individuales con instalaciones modernas forman una sola unidad de vacaciones, ofreciendo privacidad para su familia o amigos. Desde la gran terraza sombreada se contempla el parque infantil y la piscina. Puede preparar sus comidas en la cocina exterior y relajarse en la hamaca. No está rodeado de vecinos, sino que puede disfrutar de todo lo que ofrece este acogedor, pequeño, familiar y sostenible resort.",
          size: "100 m²",
          guests: 6,
          view: "Naturaleza, piscina, huerto",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca-1350x581.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-2-camping-pods.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_front-view.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_sideview.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_master-bed.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_kitchen.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-to-pool.jpg",
          ],
          amenities: ["Wi-Fi", "Piscinas Climatizadas", "Barbacoa Privada", "Cocina Exterior", "Baño Privado", "Aparcamiento", "Ropa de Cama"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "cabanas-figo",
          name: "Cabanas O Figo",
          tagline: "Vida al aire libre con Privacidad Total",
          description: "Venga a disfrutar de la vida al aire libre en este encantador alojamiento de glamping de madera con el lujo de una 'tiny house'. Consta de 2 cabañas con mucha privacidad y su propio higuero. El sol y la sombra crean un entorno maravilloso desde la mañana temprano hasta la tarde. Los niños disfrutan jugando en el bosque de juegos mientras papá enciende la gran barbacoa.",
          size: "90 m²",
          guests: 5,
          view: "Jardín, naturaleza",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_front-view-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_terrace-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_garden-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_kichinette-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-Figo-cabin-3-persons-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-figo_medronho-cabin-2-persons-1.jpg",
          ],
          amenities: ["Wi-Fi", "Piscinas Climatizadas", "Barbacoa Privada", "Cocina Exterior", "Baño Privado", "Aparcamiento", "Ropa de Cama"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "cabanas-medronho",
          name: "Cabanas O Medronho",
          tagline: "Naturaleza y Tranquilidad",
          description: "Rodeado de hermosos árboles, descanse en su hamaca. Los pájaros cantan y el sol brilla. Los más pequeños juegan en su propia cabaña mientras papá sale en bicicleta. Nunca pensó que el Glamping sería tan relajante. ¡Es fantástico aquí, un lugar genial para volver el año que viene con amigos!",
          size: "90 m²",
          guests: 6,
          view: "Naturaleza, jardín",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho-02.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_cabana.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_terras.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_garden.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_kids-cabin.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-medronho-cabin-4-persons-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_private-bathroom.jpg",
          ],
          amenities: ["Wi-Fi", "Piscinas Climatizadas", "Barbacoa Privada", "Cocina Exterior", "Baño Privado", "Aparcamiento", "Ropa de Cama"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "vintage-ford",
          name: "El Ford Rojo 1972",
          tagline: "Una Experiencia Vintage Inolvidable",
          description: "¿Se va de viaje? Sí, así se siente al alojarse en este Ford vintage rojo de 1972. Una experiencia de glamping muy especial con mucha privacidad, en plena naturaleza. Podrá relajarse, conectar y no necesitará salir del recinto gracias a todas las instalaciones de juego, deporte y relax para interior y exterior.",
          size: "80 m²",
          guests: 4,
          view: "Naturaleza, jardín",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_front-view.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_terrace.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_night.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_interior.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_double-bed.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_detail.jpg",
          ],
          amenities: ["Wi-Fi", "Piscinas Climatizadas", "Barbacoa Privada", "Cocina Exterior", "Baño Privado", "Aparcamiento"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
      ],
    },
    location: {
      badge: "Ubicación",
      title: "Costa de Plata, Portugal",
      subtitle: "Entre el Parque Natural Serra de Aire e Candeeiros y las olas más grandes del mundo en Nazaré.",
      mapTitle: "Quinta das Cantigas — Alcobaça, Portugal",
      discoverLabel: "Descubra la Región",
      pois: [
        {
          name: "Nazaré",
          icon: "waves",
          distance: "15 km",
          desc: "Mundialmente famosa por las olas más grandes del mundo. Playas fantásticas, paseo marítimo con tiendas, restaurantes y entretenimiento todo el año.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/praia-do-norte.jpg",
        },
        {
          name: "Alcobaça",
          icon: "landmark",
          distance: "10 km",
          desc: "La 'Ciudad del Amor'. Monasterio Patrimonio de la Humanidad de la UNESCO, el mayor museo del vino del país y la historia de amor inmortal de Dom Pedro e Inês de Castro.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/doces-conventueis-de-alcobaca.jpg",
        },
        {
          name: "Playas",
          icon: "sun",
          distance: "15–20 km",
          desc: "La Costa de Plata tiene playas maravillosas. Praia do Norte, Praia da Nazaré y Praia de Paredes da Vitória — descubra su favorita.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/portugal-praia-paredes-da-vitoria-beach-1024x588.jpg",
        },
        {
          name: "Actividades",
          icon: "bike",
          distance: "En la región",
          desc: "Ciclismo, senderismo, surf, avistamiento de delfines, 4x4 off-road. Alquiler de bicicletas y visitas guiadas locales disponibles.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/fort-nazare.jpg",
        },
      ],
    },
    gallery: {
      badge: "Galería",
      title: "Momentos en el Glamping",
      subtitle: "Fotos reales de nuestro alojamiento — sin filtros, sin artificios. Nuestra naturaleza habla por sí sola.",
      categories: ["Todos", "Alojamientos", "Naturaleza y Jardín", "Ubicación"],
      openLabel: "Ver foto",
      closeLabel: "Cerrar",
    },
   contact: {
      badge: "Contacto",
      title: "Hablemos",
      subtitle: "¡Nos encantaría que se alojara con nosotros! Creemos en la atención personalizada y la privacidad. Respondemos lo antes posible.",
      whatsapp: "WhatsApp",
      signal: "Signal",
      contactSub: "Disponible para mensajes",
      availability: "Disponibilidad",
      availabilitySub: "Consultar calendario",
      infoTitle: "Información de contacto",
      address: "Alcobaça, Portugal",
      email: "welcome@yourholiday.pt",
      phones: "Sandra: +351 919 133 855 | Maurice: +351 919 133 750",
      office: "Oficina: +351 262 588 255",
      form: {
        name: "Nombre",
        email: "Correo electrónico",
        phone: "Teléfono",
        message: "Mensaje",
        submit: "Enviar",
    },
      info: {
        title: "Información de contacto",
        address: "Alcobaça, Costa de Plata, Portugal",
        email: "welcome@yourholiday.pt",
        phone1: "Sandra: +351 919 133 855",
        phone2: "Maurice: +351 919 133 750",
        office: "Oficina: +351 262 588 255",
        whatsapp: "WhatsApp y Signal disponibles",
        bookDirect: "Reserva directa:",
        bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        bookLabel: "Consultar disponibilidad y reservar",
      },
    },
    footer: {
      tagline: "Eco Glamping en Portugal — La Costa de Plata le espera.",
      quickLinks: "Enlaces rápidos",
      contactTitle: "Contacto",
      legalTitle: "Legal",
      privacy: "Política de Privacidad",
      terms: "Términos y Condiciones",
      complaints: "Libro de Reclamaciones",
      company: "YourHoliday.PT es una marca de Couwenberg & Van Kessel LDA. NIF 509470149",
      copyright: "© 2025 YourHoliday.PT. Todos los derechos reservados.",
      bookNow: "Reservar Ahora",
      sustainableLabel: "Turismo Sostenible",
    },
  },
fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      accommodations: "Hébergements",
      location: "Localisation",
      gallery: "Galerie",
      contact: "Contact",
      book: "Réserver",
    },
    hero: {
      badge: "Côte d'Argent, Portugal",
      title: "Glamp Your Holiday",
      subtitle: "Expériences de Glamping sur la Côte d'Argent",
      description: "Vivez la nature de près. 1 site unique entre le parc naturel Serra de Aire e Candeeiros et les plus grandes vagues du monde à Nazaré.",
      cta: "Voir les Hébergements",
      ctaBook: "Réserver Maintenant",
      scroll: "Découvrir",
    },
    about: {
      badge: "Notre Histoire",
      title: "Le Glamping tel qu'il doit être",
      text1: "Eco Glamping au Portugal — une escapade nature dans la magnifique région de la 'Côte d'Argent'. Vivez l'esprit des vacances dans nos hébergements glamping uniques sur 1 site différent dans le centre du Portugal, près de la côte.",
      text2: "Quinta das Cantigas dispose d'un total de 8 hébergements sur 10 000 m², dont 4 hébergements glamping uniques répartis entre chênes-lièges, oliviers et autres arbres fruitiers. Chacun bénéficie de soleil et d'ombre, de beaucoup d'intimité, de simplicité et d'exclusivité, avec tout le confort moderne.",
      text3: "Nous ne faisons pas de glamping conventionnel. Hospitalité, Originalité, Convivialité et Intimité — partagez des moments uniques, profitez simplement et Glamp On !",
      quote: "Think Outside, No Box Required",
      features: [
        { title: "Intimité Totale", desc: "Grands emplacements avec beaucoup d'espace et d'intimité, loin de la foule" },
        { title: "Piscines Chauffées", desc: "Un vaste espace aquatique chauffé avec des zones sécurisées dédiées aux enfants para s'amuser en toute liberté" },
        { title: "Emplacement Top", desc: "À 15 km de Nazaré et proche d'Alcobaça" },
        { title: "Famille & Amis", desc: "Éco-resort idéal pour les enfants, parfait pour les familles et les groupes d'amis" },
      ],
      hostsLabel: "Vos hôtes",
      hostsName: "Sandra & Maurice",
      hostsQuote: "Grâce à notre attention personnelle aux détails et à notre hospitalité, nous vous laissons libre de profiter avec vos amis et votre famille !",
    },
    accommodations: {
      badge: "Nos Hébergements",
      title: "4 Expériences de Glamping Uniques",
      subtitle: "Chaque hébergement est conçu pour offrir une expérience unique et inoubliable en pleine nature.",
      guests: "Personnes",
      size: "Surface",
      view: "Vue",
      amenities: "Équipements",
      book: "Réserver",
      moreInfo: "Plus d'infos",
      close: "Fermer",
      prevImg: "Précédent",
      nextImg: "Suivant",
      items: [
        {
          id: "tendas-toca",
          name: "Tendas Toca",
          tagline: "Les Tentes Aventure",
          description: "Deux 'maisons-tentes' individuelles avec des installations modernes forment une seule unité de vacances, offrant de l'intimité pour votre famille ou vos amis. De la grande terrasse ombragée, vous dominez l'aire de jeux et la piscine. Vous pouvez préparer vos repas dans la cuisine extérieure et vous détendre dans le hamac. Vous n'êtes pas entouré de voisins, mais vous pouvez profiter de tout ce que ce complexe confortable, petit, familial et durable a à offrir.",
          size: "100 m²",
          guests: 6,
          view: "Nature, piscine, verger",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca-1350x581.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-2-camping-pods.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_front-view.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_sideview.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_master-bed.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_kitchen.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-Tendas-Toca_view-to-pool.jpg",
          ],
          amenities: ["Wi-Fi", "Piscines Chauffées", "BBQ Privé", "Cuisine Extérieure", "Salle de Bain Privée", "Parking", "Linge de Lit"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "cabanas-figo",
          name: "Cabanas O Figo",
          tagline: "Vie en plein air et Intimité Totale",
          description: "Venez profiter de la vie en plein air dans ce charmant hébergement glamping en bois avec le luxe d'une 'tiny house'. Composé de 2 cabanes avec beaucoup d'intimité et votre propre figuier. Le soleil et l'ombre créent un cadre merveilleux du petit matin jusqu'en fin d'après-midi. Les enfants s'amusent dans la forêt de jeux pendant que papa allume le grand barbecue.",
          size: "90 m²",
          guests: 5,
          view: "Jardin, nature",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_front-view-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_terrace-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_garden-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Cabins-o-figo_Quinta-das-Cantigas_holiday-Portugal_kichinette-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-Figo-cabin-3-persons-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-figo_medronho-cabin-2-persons-1.jpg",
          ],
          amenities: ["Wi-Fi", "Piscines Chauffées", "BBQ Privé", "Cuisine Extérieure", "Salle de Bain Privée", "Parking", "Linge de Lit"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "cabanas-medronho",
          name: "Cabanas O Medronho",
          tagline: "Nature et Sérénité",
          description: "Entouré de magnifiques arbres, prélassez-vous dans votre hamac. Les oiseaux chantent et le soleil brille. Les plus petits jouent dans leur propre cabane pendant que papa part à vélo. Vous n'auriez jamais cru que le Glamping serait aussi relaxant. C'est fantastique ici, un endroit génial pour revenir l'année prochaine avec des amis !",
          size: "90 m²",
          guests: 6,
          view: "Nature, jardin",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho-02.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_cabana.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_terras.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_garden.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_kids-cabin.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/quinta-das-cantigas-medronho-cabin-4-persons-1.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Kleinschalig-vakantie-park-Portugal_glamping-O-medronho_private-bathroom.jpg",
          ],
          amenities: ["Wi-Fi", "Piscines Chauffées", "BBQ Privé", "Cuisine Extérieure", "Salle de Bain Privée", "Parking", "Linge de Lit"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
        {
          id: "vintage-ford",
          name: "Le Ford Rouge 1972",
          tagline: "Une Expérience Vintage Inoubliable",
          description: "Vous partez en voyage ? Oui, c'est ce que l'on ressent en séjournant dans ce Ford vintage rouge de 1972. Une expérience glamping très spéciale avec beaucoup d'intimité, en pleine nature. Vous pourrez vous détendre, vous rapprocher et n'aurez pas besoin de quitter le domaine grâce à toutes les installations de jeux, de sport et de détente pour l'intérieur et l'extérieur.",
          size: "80 m²",
          guests: 4,
          view: "Nature, jardin",
          mainImage: "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford.jpg",
          images: [
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_front-view.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_terrace.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_night.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_interior.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_double-bed.jpg",
            "https://eco.yourholiday.pt/wp-content/uploads/Glamping-Portugal-at-Quinta-das-Cantigas_red-ford_detail.jpg",
          ],
          amenities: ["Wi-Fi", "Piscines Chauffées", "BBQ Privé", "Cuisine Extérieure", "Salle de Bain Privée", "Parking"],
          bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        },
      ],
    },
    location: {
      badge: "Localisation",
      title: "Côte d'Argent, Portugal",
      subtitle: "Entre le parc naturel Serra de Aire e Candeeiros et les plus grandes vagues du monde à Nazaré.",
      mapTitle: "Quinta das Cantigas — Alcobaça, Portugal",
      discoverLabel: "Découvrez la Région",
      pois: [
        {
          name: "Nazaré",
          icon: "waves",
          distance: "15 km",
          desc: "Mondialement célèbre pour ses vagues géantes. Plages fantastiques, boulevard avec boutiques, restaurants et animations toute l'année.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/praia-do-norte.jpg",
        },
        {
          name: "Alcobaça",
          icon: "landmark",
          distance: "10 km",
          desc: "La 'Ville de l'Amour'. Monastère classé au patrimoine mondial de l'UNESCO, le plus grand musée du vin du pays, et l'histoire d'amour immortelle de Dom Pedro et Inês de Castro.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/doces-conventueis-de-alcobaca.jpg",
        },
        {
          name: "Plages",
          icon: "sun",
          distance: "15–20 km",
          desc: "La Côte d'Argent possède des plages magnifiques. Praia do Norte, Praia da Nazaré et Praia de Paredes da Vitória — découvrez votre préférée.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/portugal-praia-paredes-da-vitoria-beach-1024x588.jpg",
        },
        {
          name: "Activités",
          icon: "bike",
          distance: "Dans la région",
          desc: "Vélo, randonnée, surf, observation des dauphins, 4x4 off-road. Location de vélos et visites guidées locales disponibles.",
          image: "https://glamp.yourholiday.pt/wp-content/uploads/2021/04/fort-nazare.jpg",
        },
      ],
    },
    gallery: {
      badge: "Galerie",
      title: "Moments au Glamping",
      subtitle: "Photos réelles de notre établissement — sans filtres, sans artifice. Notre nature parle d'elle-même.",
      categories: ["Tous", "Hébergements", "Nature & Jardin", "Localisation"],
      openLabel: "Voir photo",
      closeLabel: "Fermer",
    },
   contact: {
      badge: "Contact",
      title: "Discutons",
      subtitle: "Nous serions ravis de vous accueillir ! Nous croyons en l'attention personnalisée et l'intimité. Nous répondons dès que possible.",
      whatsapp: "WhatsApp",
      signal: "Signal",
      contactSub: "Disponible pour messages",
      availability: "Disponibilité",
      availabilitySub: "Consulter le calendrier",
      infoTitle: "Informations de contact",
      address: "Alcobaça, Portugal",
      email: "welcome@yourholiday.pt",
      phones: "Sandra : +351 919 133 855 | Maurice : +351 919 133 750",
      office: "Bureau : +351 262 588 255",
      form: {
        name: "Nom",
        email: "E-mail",
        phone: "Téléphone",
        message: "Message",
        submit: "Envoyer",
     },
      info: {
        title: "Informations de contact",
        address: "Alcobaça, Côte d'Argent, Portugal",
        email: "welcome@yourholiday.pt",
        phone1: "Sandra : +351 919 133 855",
        phone2: "Maurice : +351 919 133 750",
        office: "Bureau : +351 262 588 255",
        whatsapp: "WhatsApp & Signal disponibles",
        bookDirect: "Réservation directe :",
        bookUrl: "https://book.yourholiday.pt/en/search-availability/",
        bookLabel: "Vérifier la disponibilité & réserver",
      },
    },
    footer: {
      tagline: "Eco Glamping au Portugal — La Côte d'Argent vous attend.",
      quickLinks: "Liens rapides",
      contactTitle: "Contact",
      legalTitle: "Légal",
      privacy: "Politique de Confidentialité",
      terms: "Conditions Générales",
      complaints: "Livre de Réclamations",
      company: "YourHoliday.PT est une marque de Couwenberg & Van Kessel LDA. NIF 509470149",
      copyright: "© 2025 YourHoliday.PT. Tous droits réservés.",
      bookNow: "Réserver",
      sustainableLabel: "Tourisme Durable",
sustainableLabel: "Tourisme Durable",
    },
  },
}; 
